import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const QRRedirect = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encoded = params.get("data");
    if (encoded) {
      try {
        const decodedUrl = atob(decodeURIComponent(encoded));
        console.log("Redirecting to:", decodedUrl);
        window.location.href = decodedUrl;
      } catch (e) {
        console.error("Error decoding URL:", e);
        alert("Invalid QR Code");
      }
    }
  }, [location]);

  return <p className="ps-3">Redirecting to profile...</p>;
};

export default QRRedirect;
